import React from 'react'


import { SearchBarProps } from './SearchBar'

export const DesktopSearchBar: React.FC<SearchBarProps> = ({ onChange, ...props }) => {
  return (
    <>
    </>
  )
}
